const initialState = {
  propertyRentalList: null,
  propertyRentalDetail: null,
  rentalInterestedPropertyList: null,
  assignedProject: null,
  marginHistory: null,
  nearbyLocalitiesList: null,

  propertyUpdated: false,
  arList: null,
  arView: null,
  reelsList: null,
  reelDetail: null,

  loading: false,
  listLoading: false,
  localityLoading: false,

  error: null,
  adminMarginError: null,

  adminMarginAdded: false,
  adminMarginUpdated: false,
  statusUpdated: false,
  interestedStatusUpdated: false,
  projectAssigned: false,

  vrAdded: false,
  vrRemoved: false,
  reelUploaded: false,

  arAdded: false,
  arUpdated: false,
  arDeleted: false,

  threeSixtyPrevVideoAdded: false,
  threeSixtyPrevVideoUpdated: false,

  reelsAdded: false,
  reelsUpdated: false,

  localityUpdated: false,
};

export const propertyRentalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_PROPERTY_RENTAL_LIST_REQUEST":
    case "LIST_PROPERTY_RENTAL_REQUEST":
    case "LIST_RENTAL_INTERESTED_PROPERTY_REQUEST":
    case "LIST_RENTAL_REELS_REQUEST":
      return {
        ...state,
        listLoading: false,
        error: null,
      };

    case "VIEW_PROPERTY_RENTAL_REQUEST":
    case "STATUS_PROPERTY_RENTAL_REQUEST":
    case "ADD_RENTAL_ADMIN_MARGIN_REQUEST":
    case "UPDATE_RENTAL_ADMIN_MARGIN_REQUEST":
    case "GET_RENTAL_MARGIN_HISTORY_REQUEST":
      return {
        ...state,
        marginHistoryLoading: true,   // new key, not `loading`
        error: null,
      };

    case "UPDATE_STATUS_RENTAL_INTERESTED_PROPERTY_REQUEST":
    case "ASSIGN_RENTAL_PROJECT_REQUEST":
    case "ADD_RENTAL_VR_REQUEST":
    case "REMOVE_RENTAL_VR_REQUEST":
    case "ADD_RENTAL_REEL_REQUEST":
    case "ADD_RENTAL_AR_REQUEST":
    case "LIST_RENTAL_AR_REQUEST":
    case "VIEW_RENTAL_AR_REQUEST":
    case "UPDATE_RENTAL_AR_REQUEST":
    case "DELETE_RENTAL_AR_REQUEST":
    case "ADD_RENTAL_THREE_SIXTY_PREV_VIDEO_REQUEST":
    case "UPDATE_RENTAL_THREE_SIXTY_PREV_VIDEO_REQUEST":
    case "ADD_RENTAL_REELS_REQUEST":
    case "UPDATE_RENTAL_REELS_REQUEST":
    case "VIEW_RENTAL_REELS_REQUEST":
    case "UPDATE_PROPERTY_RENTAL_REQUEST":
    case "UPDATE_RENTAL_OWNER_VERIFIED_REQUEST":
    case "UPDATE_RENTAL_PROPERTY_MEDIA_REQUEST":
    case "UPDATE_RENTAL_FLOOR_PLAN_IMAGE_REQUEST":
    case "UPDATE_RENTAL_LOCALITY_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "NEARBY_LOCALITIES_REQUEST":
      return {
        ...state,
        localityLoading: true,
        error: null,
      };

    case "GET_PROPERTY_RENTAL_LIST_SUCCESS":
    case "LIST_PROPERTY_RENTAL_SUCCESS":
      return {
        ...state,
        listLoading: false,
        propertyRentalList: action.payload,
        error: null,
      };

    case "GET_PROPERTY_RENTAL_LIST_FAILED":
    case "LIST_PROPERTY_RENTAL_FAILED":
      return {
        ...state,
        listLoading: false,
        error: action.payload,
      };

    case "VIEW_PROPERTY_RENTAL_SUCCESS":
      return {
        ...state,
        loading: false,
        propertyRentalDetail: action.payload,
        error: null,
      };

    case "VIEW_PROPERTY_RENTAL_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "STATUS_PROPERTY_RENTAL_SUCCESS":
      return {
        ...state,
        loading: false,
        statusUpdated: true,
        error: null,
      };

    case "STATUS_PROPERTY_RENTAL_FAILED":
      return {
        ...state,
        loading: false,
        statusUpdated: false,
        error: action.payload,
      };

    case "ADD_RENTAL_ADMIN_MARGIN_SUCCESS":
      return {
        ...state,
        loading: false,
        adminMarginAdded: true,
        adminMarginError: null,
      };

    case "ADD_RENTAL_ADMIN_MARGIN_FAILED":
      return {
        ...state,
        loading: false,
        adminMarginAdded: false,
        adminMarginError: action.payload,
      };

    case "UPDATE_RENTAL_ADMIN_MARGIN_SUCCESS":
      return {
        ...state,
        loading: false,
        adminMarginUpdated: true,
        adminMarginError: null,
      };

    case "UPDATE_RENTAL_ADMIN_MARGIN_FAILED":
      return {
        ...state,
        loading: false,
        adminMarginUpdated: false,
        adminMarginError: action.payload,
      };

    case "GET_RENTAL_MARGIN_HISTORY_SUCCESS":
      return {
        ...state,
        loading: false,
        marginHistory: action.payload.data,
        error: null,
      };

    case "GET_RENTAL_MARGIN_HISTORY_FAILED":
      return {
        ...state,
        loading: false,
        marginHistory: null,
        error: action.payload,
      };

    case "LIST_RENTAL_INTERESTED_PROPERTY_SUCCESS":
      return {
        ...state,
        listLoading: false,
        rentalInterestedPropertyList: action.payload,
        error: null,
      };

    case "LIST_RENTAL_INTERESTED_PROPERTY_FAILED":
      return {
        ...state,
        listLoading: false,
        error: action.payload,
      };

    case "UPDATE_STATUS_RENTAL_INTERESTED_PROPERTY_SUCCESS":
      return {
        ...state,
        loading: false,
        interestedStatusUpdated: true,
        error: null,
      };

    case "UPDATE_STATUS_RENTAL_INTERESTED_PROPERTY_FAILED":
      return {
        ...state,
        loading: false,
        interestedStatusUpdated: false,
        error: action.payload,
      };

    case "ASSIGN_RENTAL_PROJECT_SUCCESS":
      return {
        ...state,
        loading: false,
        assignedProject: action.payload,
        projectAssigned: true,
        error: null,
      };

    case "ASSIGN_RENTAL_PROJECT_FAILED":
      return {
        ...state,
        loading: false,
        projectAssigned: false,
        error: action.payload,
      };

    case "ADD_RENTAL_VR_SUCCESS":
      return {
        ...state,
        loading: false,
        vrAdded: true,
        error: null,
      };

    case "ADD_RENTAL_VR_FAILED":
      return {
        ...state,
        loading: false,
        vrAdded: false,
        error: action.payload,
      };

    case "REMOVE_RENTAL_VR_SUCCESS":
      return {
        ...state,
        loading: false,
        vrRemoved: true,
        error: null,
      };

    case "REMOVE_RENTAL_VR_FAILED":
      return {
        ...state,
        loading: false,
        vrRemoved: false,
        error: action.payload,
      };

    case "ADD_RENTAL_REEL_SUCCESS":
      return {
        ...state,
        loading: false,
        reelUploaded: true,
        error: null,
      };

    case "ADD_RENTAL_REEL_FAILED":
      return {
        ...state,
        loading: false,
        reelUploaded: false,
        error: action.payload,
      };

    case "ADD_RENTAL_AR_SUCCESS":
      return {
        ...state,
        loading: false,
        arAdded: true,
        error: null,
      };

    case "ADD_RENTAL_AR_FAILED":
      return {
        ...state,
        loading: false,
        arAdded: false,
        error: action.payload,
      };

    case "LIST_RENTAL_AR_SUCCESS":
      return {
        ...state,
        loading: false,
        arList: action.payload,
        error: null,
      };

    case "LIST_RENTAL_AR_FAILED":
      return {
        ...state,
        loading: false,
        arList: null,
        error: action.payload,
      };

    case "VIEW_RENTAL_AR_SUCCESS":
      return {
        ...state,
        loading: false,
        arView: action.payload,
        error: null,
      };

    case "VIEW_RENTAL_AR_FAILED":
      return {
        ...state,
        loading: false,
        arView: null,
        error: action.payload,
      };

    case "UPDATE_RENTAL_AR_SUCCESS":
      return {
        ...state,
        loading: false,
        arUpdated: true,
        error: null,
      };

    case "UPDATE_RENTAL_AR_FAILED":
      return {
        ...state,
        loading: false,
        arUpdated: false,
        error: action.payload,
      };

    case "DELETE_RENTAL_AR_SUCCESS":
      return {
        ...state,
        loading: false,
        arDeleted: true,
        error: null,
      };

    case "DELETE_RENTAL_AR_FAILED":
      return {
        ...state,
        loading: false,
        arDeleted: false,
        error: action.payload,
      };

    case "ADD_RENTAL_THREE_SIXTY_PREV_VIDEO_SUCCESS":
      return {
        ...state,
        loading: false,
        threeSixtyPrevVideoAdded: true,
        error: null,
      };

    case "ADD_RENTAL_THREE_SIXTY_PREV_VIDEO_FAILED":
      return {
        ...state,
        loading: false,
        threeSixtyPrevVideoAdded: false,
        error: action.payload,
      };

    case "UPDATE_RENTAL_THREE_SIXTY_PREV_VIDEO_SUCCESS":
      return {
        ...state,
        loading: false,
        threeSixtyPrevVideoUpdated: true,
        error: null,
      };

    case "UPDATE_RENTAL_THREE_SIXTY_PREV_VIDEO_FAILED":
      return {
        ...state,
        loading: false,
        threeSixtyPrevVideoUpdated: false,
        error: action.payload,
      };

    case "ADD_RENTAL_REELS_SUCCESS":
      return {
        ...state,
        loading: false,
        reelsAdded: true,
        error: null,
      };

    case "ADD_RENTAL_REELS_FAILED":
      return {
        ...state,
        loading: false,
        reelsAdded: false,
        error: action.payload,
      };

    case "UPDATE_RENTAL_REELS_SUCCESS":
      return {
        ...state,
        loading: false,
        reelsUpdated: true,
        error: null,
      };

    case "UPDATE_RENTAL_REELS_FAILED":
      return {
        ...state,
        loading: false,
        reelsUpdated: false,
        error: action.payload,
      };

    case "LIST_RENTAL_REELS_SUCCESS":
      return {
        ...state,
        listLoading: false,
        reelsList: action.payload,
        error: null,
      };

    case "LIST_RENTAL_REELS_FAILED":
      return {
        ...state,
        listLoading: false,
        reelsList: null,
        error: action.payload,
      };

    case "VIEW_RENTAL_REELS_SUCCESS":
      return {
        ...state,
        loading: false,
        reelDetail: action.payload,
        error: null,
      };

    case "VIEW_RENTAL_REELS_FAILED":
      return {
        ...state,
        loading: false,
        reelDetail: null,
        error: action.payload,
      };

    case "UPDATE_PROPERTY_RENTAL_SUCCESS":
      return {
        ...state,
        loading: false,
        propertyRentalDetail: action.payload,
        propertyUpdated: true,
        error: null,
      };

    case "UPDATE_PROPERTY_RENTAL_FAILED":
      return {
        ...state,
        loading: false,
        propertyUpdated: false,
        error: action.payload,
      };

    case "UPDATE_RENTAL_OWNER_VERIFIED_SUCCESS":
      return {
        ...state,
        loading: false,
        propertyRentalDetail: action.payload,
        ownerVerifiedUpdated: true,
        error: null,
      };

    case "UPDATE_RENTAL_OWNER_VERIFIED_FAILED":
      return {
        ...state,
        loading: false,
        ownerVerifiedUpdated: false,
        error: action.payload,
      };

    case "UPDATE_RENTAL_PROPERTY_MEDIA_SUCCESS":
      return {
        ...state,
        loading: false,
        propertyRentalDetail: action.payload,
        propertyMediaUpdated: true,
        error: null,
      };

    case "UPDATE_RENTAL_PROPERTY_MEDIA_FAILED":
      return {
        ...state,
        loading: false,
        propertyMediaUpdated: false,
        error: action.payload,
      };

    case "UPDATE_RENTAL_FLOOR_PLAN_IMAGE_SUCCESS":
      return {
        ...state,
        loading: false,
        propertyRentalDetail: action.payload,
        floorPlanImageUpdated: true,
        error: null,
      };

    case "UPDATE_RENTAL_FLOOR_PLAN_IMAGE_FAILED":
      return {
        ...state,
        loading: false,
        floorPlanImageUpdated: false,
        error: action.payload,
      };

    case "UPDATE_RENTAL_LOCALITY_SUCCESS":
      return {
        ...state,
        loading: false,
        propertyRentalDetail: action.payload,
        localityUpdated: true,
        error: null,
      };

    case "UPDATE_RENTAL_LOCALITY_FAILED":
      return {
        ...state,
        loading: false,
        localityUpdated: false,
        error: action.payload,
      };

    case "NEARBY_LOCALITIES_SUCCESS":
      return {
        ...state,
        localityLoading: false,
        nearbyLocalitiesList: action.payload,
        error: null,
      };

    case "NEARBY_LOCALITIES_FAILED":
      return {
        ...state,
        localityLoading: false,
        nearbyLocalitiesList: null,
        error: action.payload,
      };

    case "CLEAR_PROPERTY_RENTAL_FLAGS":
      return {
        ...state,
        adminMarginAdded: false,
        adminMarginUpdated: false,
        statusUpdated: false,
        propertyUpdated: false,
        interestedStatusUpdated: false,
        projectAssigned: false,
        vrAdded: false,
        vrRemoved: false,
        reelUploaded: false,
        arAdded: false,
        arUpdated: false,
        arDeleted: false,
        threeSixtyPrevVideoAdded: false,
        threeSixtyPrevVideoUpdated: false,
        reelsAdded: false,
        reelsUpdated: false,
        ownerVerifiedUpdated: false,
        propertyMediaUpdated: false,
        floorPlanImageUpdated: false,
        localityUpdated: false,
        error: null,
        adminMarginError: null,
      };

    case "STOP_LOADING":
      return {
        ...state,
        loading: false,
        listLoading: false,
        localityLoading: false,
      };

    default:
      return state;
  }
};